if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    connectedCallback() {
      if (this.allowDebug()) console.log('ProductInfo connectedCallback', this);
      if (!this.input) {
        if (this.allowDebug()) console.log('ProductInfo input not found');
        return;
      };
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) {
        if (this.allowDebug()) console.log('ProductInfo quantityForm not found');
        return;
      };
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });

      document.addEventListener('dcb:bundle-is-sold-out', () => {
        this.toggleButton(true);
      });

      document.addEventListener('dcb:bundle-is-available', () => {
        this.toggleButton();
      });

      this.addEventListener('quantity-offers:change', (event) => {
        this.handleQuantityOfferChange(event);
      });

      this.handleInitialQuantityOffer();
    }

    allowDebug() {
      return this.classList.contains('debug');
    }

    handleQuantityOfferChange(event) {
      if (this.allowDebug()) console.log('ProductInfo handleQuantityOfferChange', event);
      if(!this.input) return;
      const quantityOfferValue = event.detail?.value || 1;
      this.input.value = quantityOfferValue;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleInitialQuantityOffer() {
      if (this.allowDebug()) console.log('ProductInfo handleInitialQuantityOffer', this);
      if(!this.input) return;
      const quantityOffer = this.querySelector('quantity-offers input[name="Quantity Offer"]:checked');
      if (!quantityOffer) return;
      this.input.value = quantityOffer.value || this.input.value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      const quantityOffer = this.querySelector('quantity-offers input[name="Quantity Offer"]:checked');
      if (quantityOffer) {
        this.input.value = min * quantityOffer.value;
      }
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) {
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }

    toggleButton(disabled = false) {
      const buttonLabel = disabled === false ? window.variantStrings.addToBag : window.variantStrings.soldOut;

      if (this.submitButton.querySelector('span')) {
        this.submitButton.querySelector('span').textContent = buttonLabel;
      } else {
        this.submitButton.textContent = buttonLabel;
      }
      this.submitButton.toggleAttribute('disabled', disabled);
    }
  }

  customElements.define('product-info', ProductInfo);
};



